/* Movatic WMS — Frontend | CesarFilho 932048016 */
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export default function WorkforceTasks() {
  const { data, isLoading } = useQuery({
    queryKey: ['tasks'],
    queryFn: async () => (await api.get('/api/workforce/tasks/')).data,
  })
  return (
    <div className="card p-4">
      <h2 className="text-lg font-semibold">Tarefas</h2>
      <pre className="mt-2 text-sm overflow-auto">{isLoading ? 'Carregando...' : JSON.stringify(data ?? [], null, 2)}</pre>
    </div>
  )
}
